export const consoleId = {
  PS5_Disc: "01",
  XboxSeriesX: "02",
  NintendoSwitch: "03",
  PS4: "04",
  XboxOne: "05",
  WiiU: "06",
  PS3: "07",
  Xbox360: "08",
  Wii: "09",
  PS2: "10",
  Xbox: "11",
  GameCube: "12",
  Other: "99",
};

export const models = {
  C10xx: "01",
  C11xx: "02",
  C12xx: "03",
  C20xx: "04",
};
